import React from 'react';
import PropTypes from 'prop-types';
import Timeline from '@mui/lab/Timeline';
import { withStyles } from '@mui/styles';

const CustomTimeline = withStyles({
  root: {
    direction: 'ltr',
  },
})(Timeline);

const UiTimeline = ({ children, ...props }) => {
  return <CustomTimeline {...props}>{children}</CustomTimeline>;
};

UiTimeline.propTypes = {
  children: PropTypes.array,
};

export default UiTimeline;
